import { Component, Inject, inject, OnInit, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Product } from '../../models';
import { isMultiDimensionProduct } from '../../utils/product-utils';
import { BaseGridCardV2Component } from '../base-grid-card-v2/base-grid-card-v2.component';
import { LocationConfigService } from './../../services/location-config/location-config.service';
import { PriceConfigService } from '../../services/price-config/price-config.service';
import { NavigationConfig } from '../../models/navigation-config';
import { BaseViewConfigService, ProductViewType } from '../../services/base-view-config/base-view-config.service';
import { ProductAssortmentParentService } from '../../services/product-assortment-parent/product-assortment-parent.service';
import { catchError, first, map, Observable, of, switchMap } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'lib-product-grid-card-v2',
  templateUrl: './product-grid-card-v2.component.html',
  styleUrls: ['./product-grid-card-v2.component.scss'],
  standalone: false
})
export class ProductGridCardV2Component extends BaseGridCardV2Component implements OnInit {
  adjustedScroll = false;
  isStandardErp = false;

  protected router = inject(Router);
  protected locationConfigService = inject(LocationConfigService);
  protected priceConfigService = inject(PriceConfigService);
  protected baseViewConfigService = inject(BaseViewConfigService);
  protected productAssortmentParentService = inject(ProductAssortmentParentService);
  protected authService = inject(AuthService);


  constructor(
    @Optional()
    @Inject('environment')
    public environment: NavigationConfig
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.data.product?.extra?.gme) {
      this.isStandardErp = true;
    }
  }

  getIsMultiDimensionProduct(product: Product): boolean {
    return isMultiDimensionProduct(product);
  }

  goToDetail(product: Product): void {
    if (this.baseViewConfigService.productViewType === ProductViewType.assortmentTreeView) {
      this.getPathInfo(product.id).pipe(first()).subscribe(path => {
        if (path) {
          this.router.navigate([path]);
        } else {
          this.basicNavigation(product);
        }
      });
    } else {
      this.basicNavigation(product);
    }
  }

  protected getPathInfo(id: string): Observable<string> {
    return this.authService.getCurrentUser().pipe(
      first(),
      switchMap(user => this.productAssortmentParentService.getProductAssortmentParentByProductIds([id], user.assortment)),
      catchError(() => of([])),
      map(results => {
        const result: { id: string, path: string }[] = [];

        for (const key in results) {
          if (results.hasOwnProperty(key)) {
            const element: { id: string }[] = structuredClone(results[key]);
            element.shift();
            result.push({
              id: key,
              path: [
                '/articles',
                ...element.map(e => e.id)
              ].join('/')
            });
          }
        }

        return result[0]?.path;
      })
    );
  }

  protected basicNavigation(product: Product): void {
    if (product?.productType === 'concept') {
      this.router.navigate(['/concept/', product.id]);
    } else {
      this.router.navigate(['/product/', product.id]);
    }
  }
}
